<template>
  <div>
    <Accordion :activeIndex="activeIndex">
	    <AccordionTab header="Filtro">
        <d-form-row>
	    	  <d-col md="3" class="form-group">
            <label>Data de Vencimento Inicial</label>
            <date-field v-model="privateFilter.DateInitial" :maxDate="privateFilter.DateEnd" />
            <div class="invalid-feedback d-block" v-if="isFilterDateInvalid">
              Deve ser menor ou igual à Data Final.
            </div>
          </d-col>
          <d-col md="3" class="form-group">
            <label>Data de Vencimento Final</label>
            <date-field v-model="privateFilter.DateEnd" :minDate="privateFilter.DateInitial" />
            <div class="invalid-feedback d-block" v-if="isFilterDateInvalid">
              Deve ser maior ou igual à Data Inicial.
            </div>
          </d-col>
          <d-col md="3" class="form-group">
            <label>Valor Inicial</label>
            <decimal-field :type="'currency'" v-model="privateFilter.AmountInitial" />
            <div class="invalid-feedback d-block" v-if="isFilterAmountInvalid">
              Deve ser menor ou igual ao Valor Final.
            </div>
          </d-col>
          <d-col md="3" class="form-group">
            <label>Valor Final</label>
            <decimal-field :type="'currency'" v-model="privateFilter.AmountEnd" />
            <div class="invalid-feedback d-block" v-if="isFilterAmountInvalid">
              Deve ser maior ou igual ao Valor Inicial.
            </div>
          </d-col>
          <d-col md="4" class="form-group">
            <label>Cedente</label>
            <d-form-input type="text" v-model="privateFilter.SupplierName" />
          </d-col>
          <d-col md="4" class="form-group">
            <label>Documento do Cedente</label>
            <the-mask class="form-control" type="text" :mask="['###.###.###-##', '##.###.###/####-##']" 
              v-model="privateFilter.SupplierIdentity"/>
          </d-col>
          <d-col md="4" class="form-group">
            <label>Categoria</label>
            <d-select v-model="privateFilter.AccountsPayableCategoryCode">
              <option :value="null" selected>Todas</option>
              <option v-for="accounts in filterOptions.AccountsPayableCategory" :key="accounts.Code" :value="accounts.Code">
                {{ accounts.Name }}
              </option>
            </d-select>
          </d-col>
          <d-col md="11" class="form-group">
            <label>Descrição</label>
            <d-form-input type="text" v-model="privateFilter.Description" />
          </d-col>
          <d-col md="1" class="form-group align-vertical-bottom">
            <b-button class="btn btn-primary" @click="ListUnconciliatedPayable()" title="Pesquisar" 
              v-b-tooltip.hover.bottom variant="primary" :disabled="isFilterDateInvalid || isFilterAmountInvalid">
              <i class="fas fa-search" />
            </b-button>
          </d-col>
        </d-form-row>
	    </AccordionTab>
    </Accordion>
    <TableList v-if="listUnconciliatedPayable" :headers="headers" :itemList="listUnconciliatedPayable" 
        @List="ListUnconciliatedPayable" :authorizeActions="[]" :pagination="pagination" :isLoading.sync="loading"
        :additionalActions="additionalActions" @MakeConciliation="MakeConciliation" :noHeader="true"/>
  </div>
</template>

<script>
import { hasValue } from "../../../utils/functions.js";

import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import TableList from "../../sub-components/Generic/TableList/TableList.vue";
import DateField from "../../common/date-field";
import DecimalField from "../../common/decimal-field.vue";

const methods = {
  ShowConciliated: function (data){
    if(data.Amount){
      return this.conciliated.Amount == data.Amount;
    }
    else{
      return false;
    }
  },
}

export default {
  name: "BankConciliationPayable",
  components: {
    Accordion,
    AccordionTab,
    TableList,
    DateField,
    DecimalField
  },
  props: {
    filterOptions:{
      type: Object,
      required: true,
    },
    conciliated:{
      type: Object,
      required: true,
    },
  },
  data(){
    return {
      tableName: 'Contas a Pagar',
      headers: [
        { field: "SupplierName", label: "Razão Social/Nome", classHeader: 'text-left', classField: 'text-left' },
        { field: "SupplierIdentity", label: "CNPJ/CPF", type:'identity', classHeader: 'text-left', classField: 'text-left break-line' },
        { field: "CategoryName", label: "Categoria", classHeader: 'text-left', classField: 'text-left' },
        { field: "DueDate", label: "Data de Vencimento", type: 'date', classHeader: 'text-left', classField: 'text-left' },
        { field: "Amount", label: "Valor", type: 'currency', classHeader: 'text-left', classField: 'text-left' },
        { field: "Description", label: "Descrição", classHeader: 'text-left', classField: 'text-left same-line' },
      ],
      additionalActions: [
        { name: 'MakeConciliation', label: 'Conciliar', icon: 'fas fa-exchange-alt', customRule:methods.ShowConciliated.bind({conciliated:this.conciliated}) }
      ],
      listUnconciliatedPayable: null,

      privateFilter: this.FilterDefault(),
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      loading: false,
      activeIndex: null
    }
  },
  mounted(){
    setTimeout(() => {
        this.activeIndex = 0;
    }, 70);
  },
  computed:{
    isFilterDateInvalid(){
      return this.privateFilter.DateInitial > this.privateFilter.DateEnd;
    },
    isFilterAmountInvalid(){
      return hasValue(this.privateFilter.AmountInitial) && hasValue(this.privateFilter.AmountEnd) && this.privateFilter.AmountInitial > this.privateFilter.AmountEnd;
    },
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListBankConciliation();
    },
    "pagination.RowsPerPage": function () {
      this.ListBankConciliation();
    },
    "activeIndex": function () {
      this.RemoveBodyClass('.p-accordion.p-component', 'p-component')
    },
  },
  methods:{
    FilterDefault: function () {
      return {
        DateInitial: this.AddDays(this.conciliated.EntryDate, -1),
        DateEnd: this.AddDays(this.conciliated.EntryDate, +3),
        AmountInitial: this.conciliated.Amount - parseInt(this.PercentValue(this.conciliated.Amount, 10).toFixed(2)),
        AmountEnd: this.conciliated.Amount + parseInt(this.PercentValue(this.conciliated.Amount, 10).toFixed(2)),
        SupplierName: null,
        SupplierIdentity: null,
        Description: null,
        AccountsPayableCategoryCode: null
      }
    },

    PercentValue(amount, percentage){
      return amount*percentage/100;
    },
    
    AddDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result.toJSON().split('T')[0];
    },

    GetParams(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Bank.Code": this.privateFilter.BankCode,
        "Object.Description": this.privateFilter.Description,
        "Object.SupplierName": this.privateFilter.SupplierName,
        "Object.SupplierIdentity": this.privateFilter.SupplierIdentity,
        "DateInitial": this.privateFilter.DateInitial,
        "DateEnd": this.privateFilter.DateEnd,
        "AmountInitial": this.privateFilter.AmountInitial,
        "AmountEnd": this.privateFilter.AmountEnd,
        "AccountsPayableCategory.Code": this.privateFilter.AccountsPayableCategoryCode
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    ListUnconciliatedPayable() {
      this.listUnconciliatedPayable = [];
      this.loading = true;
      const params = this.GetParams();
      this.$store.dispatch("ListUnconciliatedPayable", params)
        .then(response => {
          this.listUnconciliatedPayable = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Tente novamente.", "danger", "Um erro ocorreu ao listar as conciliações.", error);
        })
        .finally(() => {
          this.loading = false;
          this.activeIndex = null;
        });
    },
    MakeConciliation(toConciliate) {
      this.$emit('MakeConciliation', toConciliate);
    },
    RemoveBodyClass(locate, classToRemove) {
      const el = document.querySelector(locate);
      if(el){
        el.classList.remove(classToRemove);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.align-vertical-bottom {
  display: flex;
  justify-content: end; /* align horizontal */
  align-items: end;
  padding-bottom: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/BankConciliation/BankConciliationPayable.vue